import React from 'react';

import AKTranslateIcon from '@atlaskit/icon/core/translate';

export const TranslateIcon = () => (
	<AKTranslateIcon label="" color="currentColor" spacing="spacious" />
);
